import React from "react";
import SVG from "react-inlinesvg";
import { getSemanticIconClasses } from "../theme/semanticClasses";
import { toAbsoluteUrl } from "./assetHelper";

type Props = {
  className?: string;
  path: string;
  svgClassName?: string;
  fill?: string;
  stroke?: string;
  color?: string;
};

const getFillClasses = (fill?: string) => {
  if (fill === "currentColor") {
    return "[&_path]:!fill-current [&_rect]:!fill-current";
  }

  if (fill === "white" || fill === "#fff" || fill === "#ffffff") {
    return getSemanticIconClasses("light");
  }

  if (fill === "black" || fill === "#000" || fill === "#000000") {
    return getSemanticIconClasses("dark");
  }

  return "";
};

const KTSVG: React.FC<Props> = ({
  className = "",
  path,
  svgClassName = "h-[15px] w-[15px]",
  fill,
  stroke,
  color,
}) => {
  const hasExplicitColorClass = className.includes("[&_");
  const iconColorClasses =
    getFillClasses(fill) ||
    (!hasExplicitColorClass ? getSemanticIconClasses("secondary") : "");

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center leading-none [&_[fill=none]]:!fill-none ${iconColorClasses} ${className}`}>
      <SVG
        src={toAbsoluteUrl(path)}
        className={svgClassName}
        fill={fill}
        color={color ?? fill}
        stroke={stroke}
      />
    </span>
  );
};

export { KTSVG };
